import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type BottomNavigationValues = "create" | "polls" | "whatsApp";

interface PollsState {
    activeBottomNavigation: BottomNavigationValues;
    commentDrawerVisibility: boolean;
    showInterestDialog: boolean;
}

const initialState: PollsState = {
    activeBottomNavigation: "polls",
    commentDrawerVisibility: false,
    showInterestDialog: false,
};

export const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setBottomNavigation: (state, action: PayloadAction<BottomNavigationValues>) => {
            state.activeBottomNavigation = action.payload;
        },
        setCommentDrawerVisibility: (state, action: PayloadAction<boolean>) => {
            state.commentDrawerVisibility = action.payload;
        },
        setShowInterestDialog: (state, action: PayloadAction<boolean>) => {
            state.showInterestDialog = action.payload;
        },
    },
});

export const {
    setBottomNavigation,
    setCommentDrawerVisibility,
    setShowInterestDialog,
} = appSlice.actions;

export default appSlice.reducer;
